import { parseCalendarAttendees } from '../calendar-domain.js';
import type {
  CalendarEvent,
  CalendarReconcileContext,
} from './calendar-view-types.js';

const PROMPT_SUPPRESSION_KEY_PREFIX =
  'streamlain:calendar-mail-prompt-suppressed-until:v1';
const PROMPT_SUPPRESSION_MS = 30 * 60 * 1000;

export function calendarEventHasMailRecipients(event: CalendarEvent): boolean {
  return parseCalendarAttendees(event.attendees).some(attendee =>
    Boolean(attendee.email)
  );
}

export function isCalendarMailPromptSuppressed(
  context: CalendarReconcileContext,
  viewId: string
): boolean {
  const until = Number(readStorage(promptSuppressionKey(context, viewId)));
  return Number.isFinite(until) && until > Date.now();
}

export function suppressCalendarMailPrompt(
  context: CalendarReconcileContext,
  viewId: string
): void {
  writeStorage(
    promptSuppressionKey(context, viewId),
    String(Date.now() + PROMPT_SUPPRESSION_MS)
  );
}

function promptSuppressionKey(
  context: CalendarReconcileContext,
  viewId: string
): string {
  return [
    PROMPT_SUPPRESSION_KEY_PREFIX,
    context.actorUserId ?? 'unknown-actor',
    context.workspaceId,
    context.docId,
    context.databaseId,
    viewId,
  ].join(':');
}

function readStorage(key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) || null;
  } catch {
    return null;
  }
}

function writeStorage(key: string, value: string | null): void {
  try {
    if (!value) {
      globalThis.localStorage?.removeItem(key);
    } else {
      globalThis.localStorage?.setItem(key, value);
    }
  } catch {
    // Private browsing/quota errors should not block calendar editing.
  }
}
